var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var toNonNegativeInt = function (value, fallback) {
    var numericValue = Number(value);
    if (Number.isFinite(numericValue) && numericValue >= 0) {
        return Math.trunc(numericValue);
    }
    return fallback;
};
var pageReducer = function (items, action) {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (action.type) {
        case "UPDATE_PAGE_PARAMS": {
            var nextItem = (_a = action === null || action === void 0 ? void 0 : action.item) !== null && _a !== void 0 ? _a : {};
            return __assign(__assign(__assign({}, items), nextItem), { pg: toNonNegativeInt(nextItem.pg, (_b = items === null || items === void 0 ? void 0 : items.pg) !== null && _b !== void 0 ? _b : 0), pgSz: toNonNegativeInt(nextItem.pgSz, (_c = items === null || items === void 0 ? void 0 : items.pgSz) !== null && _c !== void 0 ? _c : 25) });
        }
        case "CHANGE_SORT_TYPE": {
            return __assign(__assign({}, items), { sortBy: (_e = (_d = action === null || action === void 0 ? void 0 : action.item) === null || _d === void 0 ? void 0 : _d.sortBy) !== null && _e !== void 0 ? _e : items.sortBy });
        }
        case "CHANGE_SORT_DIRECTION": {
            return __assign(__assign({}, items), { sortDir: (_g = (_f = action === null || action === void 0 ? void 0 : action.item) === null || _f === void 0 ? void 0 : _f.sortDir) !== null && _g !== void 0 ? _g : items.sortDir });
        }
        default: {
            var exhaustiveCheck = action;
            throw Error("PageReducer: Unhandled action type ".concat(String(exhaustiveCheck)));
        }
    }
};
export default pageReducer;
